import { API } from "aws-amplify";
import { settings } from '../../libs/settings-lib';

export async function fetchUserSettings() { 
  const body: any = {
    email: localStorage.getItem("username")
  }
  try {
    const res: any = await API.post("data", `/data/users`, {
      body,
    });
    return settings(res);
  } catch(e) {
    console.log(e)
    return e
  }
}




// WEBPACK FOOTER //
// ./src/utils/api/fetchUserSettings.ts